export default "__VITE_PUBLIC_ASSET__1b0f4a3a__"